import { giphyBlack, giphyLightCharcoal, giphyWhite } from '@giphy/colors'
import { IGif } from '@giphy/js-types'
import { useEffect, useState } from 'react'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import styled, { css } from 'styled-components'
import CCIcon from './img/cc'
import WatchIcon from './img/watch'
import { GACategory } from './video'

const buttonMargin = 15
const Container = styled.div<{ isHovered: boolean }>`
    ${(props) =>
        props.isHovered
            ? css`
                  opacity: 1;
              `
            : css`
                  opacity: 0;
              `}
    position: absolute;
    bottom: ${buttonMargin}px;
    right: ${buttonMargin}px;
    color: ${giphyLightCharcoal};
    transition: opacity ease-out 250ms;
    font-family: interface, Helvetica Neue, helvetica, sans-serif;
    padding: 5px;
    cursor: pointer;
`

const Icon = styled.div`
    transform: rotate(90deg);
    color: ${giphyWhite};
`

export const Nip = styled.div`
    border-bottom: 8px solid ${giphyBlack};
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    height: 0;
    margin-left: -6px;
    position: absolute;
    bottom: 16px;
    right: -12px;
    transform: rotate(90deg);
    width: 0;
`

const DropDown = styled.ul`
    position: absolute;
    bottom: -${buttonMargin + 5}px;
    right: ${buttonMargin + 10}px;
    list-style: none;
    width: max-content;
    border-radius: 3px;
    background-color: ${giphyBlack};
    padding: 10px 0;
    li {
        position: relative;
        margin: auto;
        padding: 5px 15px;
        user-select: none;
        pointer-events: cursor;
        display: flex;
        justify-content: space-between;
        column-gap: 12px;
        & > .icon {
            opacity: 0.7;
        }
        &:hover {
            color: ${giphyWhite};
            & > .icon {
                opacity: 1;
            }
        }
    }
`
const Menu = ({ gif, toggleCaptions, isHovered }: { isHovered: boolean; gif: IGif; toggleCaptions: () => void }) => {
    const [open, setOpen] = useState(false)
    // TODO upgrade all giphy-js packages
    // upgrade react giphy brand
    // remove resolutions in web app package.json
    const hasCaptions = gif.video?.captions!!
    useEffect(() => {
        if (!isHovered) setOpen(false)
    }, [isHovered, setOpen])
    return (
        <Container isHovered={isHovered}>
            <Icon
                className="ss-ellipsis"
                onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    setOpen(!open)
                }}
            ></Icon>
            {open && (
                <DropDown>
                    {hasCaptions && (
                        <li
                            onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                toggleCaptions()
                            }}
                        >
                            Show Captions
                            <CCIcon width={20} height={20} className="icon" />
                        </li>
                    )}
                    <li
                        onClick={() => {
                            googleAnalyticsEvent({ action: 'Watch on GIPHY', label: gif.id, category: GACategory })
                            window.open(gif.url, '_blank')
                        }}
                    >
                        Watch on GIPHY
                        <WatchIcon width={17} height={17} className="icon" />
                    </li>
                    <Nip />
                </DropDown>
            )}
        </Container>
    )
}
export default Menu
